
import { Component, Vue } from 'vue-property-decorator';

import Form13ProcessHeader from "@/components/process/Form13/components/Form13ProcessHeader.vue";
import Form13CaseInformation from "@/components/process/Form13/components/Form13CaseInformation.vue";
import { form13StatusInfoType } from '@/types/Information/Form13';

@Component({
    components:{
        Form13ProcessHeader,
        Form13CaseInformation
    }
})
export default class StartForm13 extends Vue {

    stepsCompleted = {} as form13StatusInfoType;   

    mounted() {  
        this.stepsCompleted = {
            first: false,
            second: false,
            third: false
        }       
    }  


}
